package com.anjuros.website.templates.template2.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template2.modules.Template2Section
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template2.styles.Template2SectionSubTitleStyle
import com.anjuros.website.templates.template2.styles.Template2SectionTitleStyle
import com.anjuros.website.templates.template2.util.ResKey
import com.anjuros.website.templates.template2.util.Template2Constants.FONT_FAMILY
import com.anjuros.website.templates.template2.util.Template2ObserverViewportEntered
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template2SectionTitle(
    modifier: Modifier = Modifier
        .fillMaxWidth(90.percent),
    title: ResKey,
    text: ResKey,
    textAlign: TextAlign = TextAlign.Center,
    light: Boolean = false
) {

    Column(
        modifier = modifier
            .margin(bottom = 50.px),
        horizontalAlignment = if(textAlign== TextAlign.Center) Alignment.CenterHorizontally else Alignment.Start
    ) {



        //====================================================
        // TITLE
        //====================================================

        H2(
            attrs = Template2SectionTitleStyle.toModifier()
                .fillMaxWidth(90.percent)

                .fontWeight(FontWeight.Bold)
                .textAlign(textAlign)
                .lineHeight(1.2)
                .color(
                    if (light)
                        Colors.White
                    else
                        Template2Theme.Primary.getColor()
                )
                .margin(bottom = 18.px)
                .toAttrs()
        ) {
            Text(LocalText(title))
        }

        //====================================================
        // TEXT
        //====================================================

        P(
            attrs = Template2SectionSubTitleStyle.toModifier()
                .fontSize(18.px)
                .lineHeight(1.8)
                .textAlign(textAlign)
                .color(
                    if (light)
                        rgba(255, 255, 255, .72)
                    else
                        rgb(110, 110, 110)
                )
                .margin(0.px)
                .toAttrs()
        ) {
            Text(LocalText(text))
        }

    }

}